var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hsm-header'),_vm._v(" "),_c('container-nav',{scopedSlots:_vm._u([{key:"default",fn:function(p){return [_c('Nav',{attrs:{"list":p.list,"styles":p.styles,"sticky":""}})]}}])}),_vm._v(" "),_c('UC',{attrs:{"menus":_vm.menus}}),_vm._v(" "),_c('hsm-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b2b668","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/uc/pageIndex.vue
// module id = null
// module chunks = 